export { default as Competition } from './Competition';
export { default as Coupons } from './Coupons.js';
export { default as Common } from './Common.js';
export { default as Description } from './Description.js';
export { default as Price } from './Price.js';
export { default as Workshop } from './Workshop.js';



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Panes/index.js